/* eslint-disable react/jsx-no-target-blank */
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import SVG from 'react-inlinesvg';
import { useContext } from 'react';
import { FileContext } from 'app/modules/accounts/Filecontext';
import { useCompany } from 'hooks/useCompany';

const SidebarFooter = () => {
  const { selectedCompany } = useContext(FileContext);
  const companyId = selectedCompany || localStorage.getItem('companyId');
  const { company, isLoading } = useCompany(companyId as number);

  const showModule = !isLoading && company?.subscribed === false;

  return (
    <div className="app-sidebar-footer flex-column-auto pt-2 pb-6 px-6" id="kt_app_sidebar_footer" style={{ flexShrink: 0 }}>
      {showModule && (
        <div className="px-3 px-md-5 py-4 py-md-6 bg-gray-150 rounded-3">
          <SVG src="/media/svg/general/rocket.svg" style={{ width: '55px', height: '55px' }} />

          <h6 className="mt-6 mb-0 fs-h2 font-medium">Upgrade My Account</h6>

          <p className="mt-3 mb-6 mb-0 fs-h4 font-secondary font-normal">
            Get priority featured, drive traffic to your website and capture more enquires.
          </p>

          <Link to="/settings/plan">
            <Button size="sm" variant="dark">
              Upgrade
            </Button>
          </Link>
        </div>
      )}
    </div>
  );
};

export { SidebarFooter };
